import type { IBusinessListRow } from "@/models/Business";

export type BusinessType = "SUPPLIER" | "BUYER";

export const BUSINESS_TYPES: BusinessType[] = ["SUPPLIER", "BUYER"];

/** The `?type=` query value for each business type. */
export const BUSINESS_TYPE_PARAM: Record<BusinessType, string> = {
  SUPPLIER: "supplier",
  BUYER: "buyer",
};

export function parseTypeParam(value: string | null): BusinessType | null {
  const found = BUSINESS_TYPES.find((type) => BUSINESS_TYPE_PARAM[type] === value?.toLowerCase());
  return found ?? null;
}

export type DrawerMode = "ADD" | "EDIT" | "DETAIL";

/** What a row hands to a drawer: the drawer re-fetches the rest with BusinessApi.get(id). */
export type BusinessRecord = Pick<
  IBusinessListRow,
  "id" | "refCode" | "profileName" | "profileNameEng" | "logo" | "isConfirmed" | "createdAt"
>;

export type RowActionKey = "edit" | "detail" | "users" | "activate" | "deactivate";

export function pickBusinessRecord(row: IBusinessListRow): BusinessRecord {
  return {
    id: row.id,
    refCode: row.refCode,
    profileName: row.profileName,
    profileNameEng: row.profileNameEng,
    logo: row.logo,
    isConfirmed: row.isConfirmed,
    createdAt: row.createdAt,
  };
}
